module.exports = __webpack_public_path__ + "static/chill-652f77ec524703323a967c7587dcdc49.jpg";